var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0935 13.2041H16.6982V1.80878C16.6982 0.795864 15.9023 0 14.8894 0C13.8765 0 13.0806 0.795864 13.0806 1.80878V13.2041H2.04706C1.03415 13.2041 0.238281 14 0.238281 15.0129C0.238281 16.0258 1.03415 16.8217 2.04706 16.8217H13.0806V27.8552C13.0806 28.8682 13.8765 29.664 14.8894 29.664C15.9023 29.664 16.6982 28.8682 16.6982 27.8552V16.8217H28.0935C29.1065 16.8217 29.9023 16.0258 29.9023 15.0129C29.9023 14 29.1065 13.2041 28.0935 13.2041Z",
    fill: "#EF6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon3);
export default __webpack_public_path__ + "static/media/upload_icon3.23de6797d2af1d4fe5214521b6dc31dd.svg";
export { ForwardRef as ReactComponent };